import type { ReactNode } from "react";

/**
 * Marca FiCC / Boaventura Group — emblema oficial (anel dourado, torres + vela
 * navy e ondas). Servido de `apps/web/public/brand-logo.png` (asset oficial do
 * usuário, em `LOGO/app_favicon.png`). Usado na sidebar e no login ao lado de
 * "FICC".
 */
export function BrandLogo({ size = 38 }: { size?: number }): ReactNode {
  return (
    <img
      src="/brand-logo.png"
      width={size}
      height={size}
      alt="FiCC — Boaventura Group"
      style={{ flex: "0 0 auto", display: "block", objectFit: "contain" }}
    />
  );
}
